/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { PutProjectsProjectidSelectionsProjectselectionidOptions, PutProjectsProjectidSelectionsProjectselectionidResponses } from '../types/PutProjectsProjectidSelectionsProjectselectionid'
import { client, withUnwrap } from '../.kubb/client'

/**
 * {@link /projects/:projectId/selections/:projectSelectionId}
 */
export function putProjectsProjectidSelectionsProjectselectionid<ThrowOnError extends boolean = true>(options: Options<PutProjectsProjectidSelectionsProjectselectionidOptions, ThrowOnError>): Unwrappable<RequestResult<PutProjectsProjectidSelectionsProjectselectionidResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(request({ method: 'PUT', url: '/projects/{projectId}/selections/{projectSelectionId}', security: [{ type: 'http', scheme: 'bearer' }], ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<PutProjectsProjectidSelectionsProjectselectionidResponses, ThrowOnError>>)
}
